import { MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { INVALID_STRING_MAX } from "@/constants/invalids";
import { replaceStr } from "@/utils/string";
import { validator } from "@/utils/validator";
import { useMemo } from "react";
import { InferType } from "yup";

// 応援メッセージ: 改行を除いた本文は50文字以内 (改行を含めた全体の文字数上限はバックエンドで担保)
const ENCOURAGEMENT_CONTENT_MAX_LENGTH = 50;

const countExcludingLineBreaks = (value: string) => value.replace(/[\r\n]/g, "").length;

/** ラベルはユーザー種別によって変わりうるため呼び出し側から注入する */
export type TLearnerNotesLabels = {
  encouragementMsg: string;
  companyReport: string;
  rsoMemo: string;
};

const buildLearnerNotesSchema = (labels: TLearnerNotesLabels) =>
  validator.object({
    encouragementMsg: validator
      .string()
      // 改行を除いた本文が50文字以内か (改行はカウントに含めない)
      .test("encouragementContentMax", "", function (value) {
        if (!value) return true;
        if (countExcludingLineBreaks(value) <= ENCOURAGEMENT_CONTENT_MAX_LENGTH) return true;
        return this.createError({
          path: this.path,
          message: ({ label }) => replaceStr(INVALID_STRING_MAX, { path: label, max: ENCOURAGEMENT_CONTENT_MAX_LENGTH }),
        });
      })
      .emptyToNull()
      .nullable()
      .label(labels.encouragementMsg)
      .notRequired(),
    companyReport: validator.string().max(MAX_TEXT_INPUT_VALIDATION).emptyToNull().nullable().label(labels.companyReport).notRequired(),
    rsoMemo: validator.string().max(MAX_TEXT_INPUT_VALIDATION).emptyToNull().nullable().label(labels.rsoMemo).notRequired(),
  });

export type TLearnerNotesForm = InferType<ReturnType<typeof buildLearnerNotesSchema>>;

/**
 * 学習者ノート (応援メッセージ / 所属機関報告 / 登録支援機関メモ) のバリデーションスキーマ。
 * ラベルはユーザー種別で異なりうるため、固定スキーマではなくフックとして提供する。
 */
export const useLearnerNotesSchema = (labels: TLearnerNotesLabels) =>
  useMemo(() => buildLearnerNotesSchema(labels), [labels]);
